import { IoClose } from "react-icons/io5";
import { IoMdCheckmark } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Modal from "../../Submissions/components/Modal";
import { useState } from "react";
import { ActionButton } from "../../../components/Forms/ActionButton";
import { useDeleteBlog, useUpdateBlogStatus } from "../../../queries/blog";
import Chip from "../../../components/Chip";
import { FaTrash } from "react-icons/fa";
import { useDeleteEvent } from "../../../queries/event";
const EditIcon = require("../../../utils/media/icons/enter.png");

const EventSubmissionList = ({ data, toast }) => {

    const navigate = useNavigate();
    const [isModelOpen, setIsModelOpen] = useState(false);
    const [isRejectionModelOpen, setIsRejectionModelOpen] = useState(false);
    const [deleteModel, setDeleteModel] = useState(false);
    const [currentId, setCurrentId] = useState(null);

    const [rejectionReason, setRejectionReason] = useState("");
    
    const { mutateAsync } = useUpdateBlogStatus();
    const { mutateAsync: deleteEvent } = useDeleteEvent();

    const handleDelete = async (id) => {
        deleteEvent(id, {
            onSuccess: () => {
                toast.success("Event Deleted");
            },
            onError: (error) => {
                toast.error(error?.response?.data?.message || "Something went wrong");
            }
        });
    }

    const renderChips = (item) => {
        if (item.reviewDate !== null) {
            if(item.allocatedPoints > 0) {
                return <Chip value={'accepted'} color="green" />
            }
            else{
                return <Chip value={'rejected'} color="red" />
            }
        } else if (item.status === 'attended') {
            return <Chip value={'attended'} color="blue" />
        } else if (item.status === 'registered') {
            return <Chip value={'registered'} color="yellow" />
        } else {
            return <Chip value={item} color="inactive" />
        }
    }

    if (!data || data.length === 0) {
        return (
            <div className="flex justify-center items-center w-full h-96">
                <h1 className="text-base text-gray-400">No Data Found</h1>
            </div>
        );
    }
    return (
        <div className="overflow-x-auto mt-6">
            <table className="w-full border-collapse overflow-visible" role="table">
                <thead className="bg-navBtn">
                    <tr className="rounded-md">
                        <th className="p-3 text-left">Srl. No.</th>
                        <th className="p-3 text-left">Title</th>
                        <th className="p-3 text-left">Submitted By</th>
                        <th className="p-3 text-center">Submitted On</th>
                        <th className="p-3 text-center">Status</th>
                        <th className="p-3 text-center">Total Event Points </th>
                        <th className="p-3 text-center">Allocated Event Points</th>
                        <th className="p-3 text-center">Referral Points</th>
                        <th className="p-3 text-center">Total Allocated Points</th>
                        {/* <th className="p-3 text-center">Event Referral Points</th> */}
                        {/* <th className="p-3 text-left">Registered At</th> */}
                        {/* <th className="p-3 text-left">Attended At</th> */}
                        <th className="p-3 text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.map((item, index) => (
                            <tr
                                key={item._id}
                                className="border-b border-navBtn hover:bg-gray-50 relative"
                            >
                                <td className="p-3 text-center">{index + 1}</td>
                                {/* <td className="p-3 capitalize">
                                    {item?.createdBy?.profilepic ? (
                                        <img src={item?.createdBy?.profilepic} alt="avatar" className="size-7 rounded-full" />
                                    ) : "-"}
                                </td> */}
                                {/* <td className="p-3">{item?.eventId?.typeOfEvent}</td> */}
                                <td className="p-3">{item?.eventId?.title}</td>
                                <td className="p-3">{item?.userId?.username}</td>
                                <td className="p-3 text-center">{item?.submissionDate?.toRegularDate() || "-"}</td>
                                {/* <td className="p-3 capitalize">{item?.challengeId?.name || "public"}</td> */}
                                <td className="p-3 capitalize text-center">{item?.status ? renderChips(item) : "-"}</td>
                                <td className="p-3 capitalize text-center">{item?.eventId?.points}</td>
                                <td className="p-3 capitalize text-center">{item?.allocatedPoints}</td>
                                <td className="p-3 capitalize text-center">{item?.referralPoints}</td>
                                <td className="p-3 capitalize text-center">{(item?.referralPoints + item?.allocatedPoints)}</td>
                                {/* <td className="p-3 capitalize text-center">{item?.allocatedReferralPoints}</td> */}
                                {/* <td className="p-3 capitalize">
                                    {item?.coverImage ? (
                                        <a
                                            href={item.coverImage}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-500 underline"
                                        >
                                            Open Image
                                        </a>
                                    ) : (
                                        "-"
                                    )}
                                </td> */}
                                {/* <td className="p-3 text-left">{new Date(item?.createdAt).toLocaleString('en-IN', { month: 'short', day: 'numeric', year: 'numeric' })}</td>
                                <td className="p-3 text-left">{item?.attendedDate ? (new Date(item?.attendedDate).toLocaleString('en-IN', { month: 'short', day: 'numeric', year: 'numeric' })) : '-'}</td> */}
                                <td className="p-3 text-center flex items-center justify-center">
                                    {/* View Button */}
                                    <button
                                        className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7"
                                        onClick={() => navigate('/events/events-submissions-details', { state: { eventSubmissionId: item?._id } })}
                                    >
                                        <img src={EditIcon} className="size-5" alt="view" />
                                    </button>
                                    {/* {
                                        item?.createdByUserType === 'user' && (
                                            item?.approvedOn ? (
                                                item?.status === 'active' ? (
                                                    // Reject Button
                                                    <button
                                                        className="rounded p-1.5 bg-[rgba(199,52,52,0.1)] hover:bg-[rgba(199,52,52,0.2)] mx-1 min-h-7"
                                                        onClick={() => {
                                                            setIsRejectionModelOpen(true);
                                                            setCurrentId(item._id);
                                                        }}
                                                    >
                                                        <IoClose className="fill-redDark" />
                                                    </button>
                                                ) : (
                                                    // Approve Button
                                                    <button
                                                        className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7"
                                                        onClick={() => {
                                                            setIsModelOpen(true);
                                                            setCurrentId(item._id);
                                                        }}
                                                    >
                                                        <IoMdCheckmark className="fill-primaryHoverDark" />
                                                    </button>
                                                )
                                            ) : (
                                                (item?.isRejected || item?.status === 'auto approved') ? (
                                                    // Approve Button
                                                    <button
                                                        className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7"
                                                        onClick={() => {
                                                            setIsModelOpen(true);
                                                            setCurrentId(item._id);
                                                        }}
                                                    >
                                                        <IoMdCheckmark className="fill-primaryHoverDark" />
                                                    </button>
                                                ) : (
                                                    // Reject Button
                                                    <button
                                                        className="rounded p-1.5 bg-[rgba(199,52,52,0.1)] hover:bg-[rgba(199,52,52,0.2)] mx-1 min-h-7"
                                                        onClick={() => {
                                                            setIsRejectionModelOpen(true);
                                                            setCurrentId(item._id);
                                                        }}
                                                    >
                                                        <IoClose className="fill-redDark" />
                                                    </button>
                                                )
                                            )
                                        )
                                    } */}
                                    {/* Delete Button */}
                                    {/* <button
                                        className="rounded p-1.5 bg-[rgba(199,52,52,0.1)] hover:bg-[rgba(199,52,52,0.2)] mx-1 min-h-7"
                                        onClick={() => {
                                            handleDelete(item._id);
                                            // setCurrentId(item._id);
                                        }}
                                    >
                                        <FaTrash className="fill-chipRed" />
                                    </button> */}
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    );
}

export default EventSubmissionList;

